import routeTypes from './RouteTypes'

const SignIn = () => import(/* webpackChunkName: "signin-chunk" */ './SignIn.vue')

export default [
  {
    path: routeTypes.SignIn.path,
    name: routeTypes.SignIn.name,
    component: SignIn,
    meta: {
      id: '',
      route: 'listing',
      title: 'FlexiQuote Sign In'
    }
  }
]
